import {z as zod} from "zod";

export type OrganizationalUnitsWorkspaceCapabilityConfiguration = Record<string, never>;

export const organizationalUnitsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OrganizationalUnitsWorkspaceCapabilityConfiguration> = zod.strictObject(
    {},
);
